import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiScrollbar, TuiScrollable } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationModule } from '@src/app/modules/navigation';

import { InformationComponent } from './information.component';

@NgModule({
  declarations: [InformationComponent],
  imports: [CommonModule, NavigationModule, TranslateModule, TuiScrollbar, TuiScrollable],
})
export class InformationModule {}
